{
  "google-salon-details-page": {
    "buttons": {
      "be-partner": "ÊTRE PARTENAIRE",
      "request": "DEMANDE"
    },
    "text": {
      "is-customer-question": "Êtes-vous client du salon ?",
      "is-customer-hint": "Si vous souhaitez une fonction de réservation en ligne pour le salon, veuillez nous le faire savoir et nous contacterons le propriétaire du salon.",
      "is-owner-question": "Vous êtes propriétaire d'un salon de coiffure ?",
      "is-owner-hint": "Devenez notre partenaire et découvrez nos fonctionnalités illimitées avec une offre initiale importante !",
      "request-sent": "VOTRE DEMANDE EST ENVOYÉE"
    }
  }
}
